import { render, staticRenderFns } from "./Subnav.vue?vue&type=template&id=742e2d29&"
import script from "./Subnav.vue?vue&type=script&lang=js&"
export * from "./Subnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports